<template>
	<div>
		<common-dialog :title="dialogTitle" :dialogVisible="visible" :width="width" @cancel="dialogCancelClick"
			@confirm="dialogConfirmClick" @dialog-close="dialogClose">
			<div class="dialog-body-wrap">
				<div v-if="dialogType === 'add' || dialogType === 'edit'">
					<div class="item-wrap">
						<label>身份名称:</label>
						<el-input v-model="addBody.title" placeholder="请输入身份名称" class="name_input"></el-input>
					</div>
					<div class="item-wrap">
						<label>管理模块:</label>
						<el-tree :data="powerTree" show-checkbox :default-expand-all="false" node-key="id" ref="tree"
							:props="defaultProps" />
					</div>
					<div class="item-wrap">
						<label>关联酒店:</label>
						<div v-if="selectHotel.length" class="select-hotel"></div>
						<div v-else class="select-hotel">暂未关联酒店</div>
					</div>
					<el-button type="primary" class="selectBth" @click="onSelectHotelClick">修改关联酒店</el-button>
				</div>
				<div v-if="dialogType === 'delete'">
					是否删除该身份？
				</div>
			</div>

		</common-dialog>
	</div>
</template>

<script>
	import CommonDialog from '@/components/CommonDialog';
	import SelectHotelDialog from './SelectHotelDialog'
	import {
		LimitsList,
		addLimitsUser,
		SetLimitsList,
		delLimitsUser
	} from '@/api/auth';
	import {
		mapState,
		mapActions
	} from 'vuex';

	export default {
		props: {
			dialogVisible: {
				type: Boolean,
				default: false
			},
			dialogTitle: {
				type: String
			},
			dialogType: {
				type: String,
			},
			handle_row: {
				type: Object
			},
			width: {
				type: String,
				default: '30%'
			}
		},
		data() {
			return {
				visible: this.dialogVisible,
				powerTree: [],
				defaultProps: {
					children: 'children',
					label: 'menu_name',
				},
				addBody: {
					title: '',
					rules_url: [],
					store_uuid: [],
					rules: [],
					rules_name: [],
					oneId: [], //存放所有一级菜单id
				},
				second_rules: [], //二级列表的权限
				selectHotel: [],
				hotelDialogVisible: false,
			};
		},
		components: {
			CommonDialog,
			SelectHotelDialog
		},
		mounted() {},
		computed: {
			...mapState(['brandData', 'hotelData']),
		},
		methods: {
			...mapActions(['getCommonInfo']),
			dialogCancelClick() {
				this.$emit('cancel');
			},
			async dialogConfirmClick() {
				// this.$emit('confirm')
				if (this.dialogType === 'edit' || this.dialogType === 'add') {
					const tree = this.$refs.tree.getCheckedNodes(true);
					const {
						title,
						brand_uuid,
						hotel_uuid
					} = this.addBody;
					if (!title) {
						this.$message('请输入身份名称')
						return
					}
					if (!brand_uuid) {
						this.$message('请选择品牌')
						return
					}
					if (!hotel_uuid) {
						this.$message('请选择酒店')
						return
					}
					if (!tree.length) {
						this.$message('请选择权限')
						return
					}
					if (!tree.length) {
						this.$message('请选择权限')
						return
					}
					let fidArr = []; //存放父级rule id 
					this.addBody.rules = [];
					this.addBody.rules_name = [];
					console.log(tree, '选中tree')
					//如果三级的时候 没有获取到最外面的一级id
					tree.forEach((item) => {
						fidArr.push(item.fid);
						this.addBody.rules.push(item.id)
						this.addBody.rules_name.push(item.menu_name)
					})
					//fidArr去重添加到权限列表 子有权限 父级肯定也有权限
					let twoId = [...new Set(fidArr)];
					//如果三级的时候 去获取到最外面的一级id
					let oneId = []
					this.powerTree.forEach(one => {
						if (one.two && one.two.length) {
							one.two.forEach(two => {
								if (twoId.includes(two.id)) {
									oneId.push(two.fid);
								}
							})
						}
					})
					let parentId = twoId.concat([...new Set(oneId)]);
					this.addBody.rules = this.addBody.rules.concat(parentId);
				}
				switch (this.dialogType) {
					case 'add': {
						const {
							status
						} = await addLimitsUser(this.addBody);
						if (status === 200) {
							this.visible = false;
							break;
						}
					}
					case 'edit': {
            debugger
            this.addBody.group_id=this.handle_row.group_id
            this.addBody.group_title=this.handle_row.group_title
            const {
							data,
							status
						} = await SetLimitsList(this.addBody);
						if (status === 200) {
							this.visible = false;
							break;
						}
					}
					case 'delete': {
						console.log(this.handle_row.group_id);
						const {
							data,
							status
						} = await delLimitsUser({
              group_id:this.handle_row.group_id
            });
						if (status === 200) {
							this.visible = false;
							break;
						}
					}
				}
			},
			dialogClose() {
				this.$emit('close');
			},
			async getLimitList() {
				const {
					data,
					status
				} = await LimitsList();
				if (status !== 200) return
				let copyData = JSON.parse(JSON.stringify(data));
				if (copyData.one.length) {
					copyData.one.forEach(one => {
						one.children = one.two;
						one.two.forEach(two => {
							two.children = two.three;
							//存放二级列表权限id
							this.second_rules.push(two.id);
						})
					})
				}
				this.powerTree = copyData.one;
			},
			onBrandChange(uuid) {
				//把选的酒店清空
				this.$set(this.addBody, 'hotel_uuid', '')
				this.getBrandHotelData(uuid);
			},
			getBrandHotelData(uuid) {
				// //获取对应品牌的酒店数据
				let brandHotel = [];
				this.hotelData.forEach(item => {
					if (item.brand_uuid === uuid) {
						brandHotel.push(item)
					}
				})
				this.brandHotel = brandHotel;
			},
			hotelDialogConfirm(data) {

			},
			onSelectHotelClick() {
				this.hotelDialogVisible = true;
			}
		},
		watch: {
			async dialogVisible(val) {

				this.visible = val;
				if (val) {
					this.getCommonInfo({
						admin_type: '1'
					});
					let row = this.handle_row;
					//getlimitlist是异步的需要加await 否则second_rules会出问题
					//await this.getLimitList();
					if (this.dialogType === 'edit') {
						//把二级列表权限去掉。否则三级权限会处于全选状态
						let rules = row.rules.filter(item => {
							return !this.second_rules.includes(item);
						})
						if (row.rules && row.rules.length && this.dialogType !== 'delete') {
							this.$nextTick(() => {
								this.addBody = JSON.parse(JSON.stringify(row));
								this.$refs.tree.setCheckedKeys(rules)
							})
						}
					}
				}
			}
		}
	};
</script>

<style lang="less" scoped>
	.dialog-body-wrap {
		text-align: center;

		.item-wrap {
			display: flex;
			margin-bottom: 30px;

			label {
				width: 80px;
				margin-right: 40px;
			}

			.name_input {
				width: 200px;
			}
		}

		.selectBth {
			display: block;
			margin-right: auto;
		}

		.select-hotel {
			flex: 1;
			padding: 20px;
			text-align: left;
			box-shadow: 0px 2px 8px 0px rgba(26, 66, 70, 0.1);
		}
	}
</style>
